<template>
  <Page v-bind="page"/>
</template>
<script>
import Page from "@/components/Page/BasisListPage.vue";
export default {
  props: {
    success: Function,
    close: Function,
    pars: Object
  },
  components: {
    Page
  },
  data() {
    return {
      page: {
        moduleInfo: {
          area: "Business",
          name: "Tutorial",
          direction: "投屏教程",
          frmColumns(cols) {
            cols.find(r => r.Name == "Content").template = {
              props: ["model"],
              render(h) {
                var text = this.model.Content.replace(/<[^<>]+>/g, "");
                return h("div", {
                  domProps: {
                    innerHTML: text
                  }
                });
              }
            };

            return cols;
          }
        },
        pageInfo: {
          success: this.success,
          close: this.close,
          pars: this.pars
        }
      }
    };
  }
};
</script>
